import Immutable from 'immutable';

export const OptionState = Immutable.fromJS({
    schd_type:[],
    conform:[],
    consult:[],
    consultGroup:[],
    schdTime:[], 
    gender:[{value:"M", label:"男"},{value:"F", label:"女"}],
    city:[],
    AREA_CODE:[],
    loading:false,   
})

export const optionalFields = {
    ROLE_PAT_IDNO:"",
    ROLE_PAT_NAME:"",
    CONFORM_TYPE_OTHERS:"",
    OUTBOUND_DATE:null,
    FLIGHT_NO:"",
    EMP_NO:""
}

export const formDefault = {    
    schdType:"",
    schdTypeName:"",
    conformId:"",
    consult:"",
    consultA:"",
    consultB:"",
    schdTimeId:"", 
    TICKET_NO:"",
    PAT_NAME:"",
    PAT_IDNO:"",
    TEL_MOBILE:"",
    EMAIL:"",
    SEX:"",
    BIRTHDAY:null,
    NATIONALITY:"",
	PASSPORT_NUMBER:"",
    PASSPORT_NAME:"",
	RC_NUMBER:"",  
    city:"", 
    AREA_CODE:"",
    ADDRESS:"",
    NO_ROC_ID:"N",
    loading:false,
    ...optionalFields
}

export const FormState = Immutable.fromJS(formDefault)

export const ResultState =  Immutable.fromJS({
    result:[]
})

export const ReserveHistoryState = Immutable.fromJS({
    search:{
        PAT_IDNO:"",
        TICKET_NO:"",
        BIRTHDAY:"",
        loading:false
    },
    result:[]
})


